<template>
  <v-card class="d-flex pa-2 flex-column" outlined>
    <v-alert
      v-model="flashError"
      dense
      border="left"
      type="error"
      dismissible
      elevation="2"
    >
      {{ flashErrorMessage }}
    </v-alert>

    <div
      class="d-flex pa-2 flex-row flex-wrap"
      :style="{ height: 'fit-content' }"
    >
      <card-row
        :title="'File Upload'"
        :textColor="'black'"
        :cardColor="'white'"
        :displayed="true"
      >
        <div style="width: 100%">
          <v-row>
            <v-col cols="12" sm="3" md="3">
              <v-dialog
                ref="rangeDateDialog"
                v-model="rangeDateDialog"
                :return-value.sync="upload.created_at"
                persistent
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    id="rangeDate"
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    v-model="dateRangeText"
                    label="Transaction Date"
                    hide-details="true"
                  />
                </template>

                <v-date-picker
                  v-model="upload.created_at"
                  scrollable
                  range
                  :min="minDate"
                  :max="maxDate"
                >
                  <v-spacer />
                  <v-btn text color="primary" @click="rangeDateDialog = false">
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="
                      () => {
                        checkRangeDate();
                        $refs.rangeDateDialog.save(upload.created_at);
                      }
                    "
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>
            <v-col cols="12" sm="3" md="4">
              <v-file-input
                accept="text/plain"
                show-size
                counter
                multiple
                label="File input"
              />
            </v-col>

            <v-col cols="12" sm="3" md="4" class="setFormInpust">
              <v-btn
                class="btnspace"
                medium
                color="primary"
                v-model="upload.file_upload"
              >
                Upload
                <v-icon right dark> mdi-cloud-upload </v-icon>
              </v-btn>
              <v-btn class="btnspace" medium @click="clearSearch">
                Reset
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </card-row>
    </div>

    <v-data-table
      :headers="headers"
      fixed-header
      :items="allData"
      :options.sync="options"
      :server-items-length="totalData"
      :loading="loading"
      loading-text="Loading... Please wait"
      :item-class="rowClass"
      class="d-print-table"
      :footer-props="{
        itemsPerPageOptions: [5, 10, 25, 50],
      }"
      item-key="id"
      sort-by="v.id"
      :sort-desc="true"
      :style="{ padding: '8px', height: '70vh' }"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-spacer />
          <template>
            <v-btn
              color="warning"
              class="mb-1"
              @click="getData"
              :loading="loading"
              :disabled="loading"
              :style="{ 'margin-right': '10px' }"
              ><v-icon>mdi-restart</v-icon></v-btn
            >
          </template>
        </v-toolbar>
      </template>
      <template v-slot:item="{ item, index }">
        <tr
          :key="index"
          :style="{ cursor: 'pointer' }"
          :class="selectedRow == index ? 'indigo lighten-5' : ''"
          @click="selectRow(index)"
        >
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ (options.page - 1) * options.itemsPerPage + index + 1 }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.mid }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.merchant_name }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.sales_volume }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.date }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            <v-icon small class="mr-2"> mdi-eye </v-icon>
          </td>
        </tr>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="clearSearch"> Reset </v-btn>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { dataMinRangeDate, dataMaxRangeDate } from '../../store/params';
import { getDate, date, showAlert } from '../../lib/helpers';

export default {
  components: {
    CardRow: () => import('../../components/CardRow.vue'),
  },
  data: () => ({
    today: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .slice(0, 10),
    isFirstLoad: true,
    rangeDateDialog: false,
    options: {},
    view: false,
    show: false,
    dialog: false,
    expanded: [],
    headers: [
      {
        text: 'No',
        align: 'start',
        width: '10',
        value: 'id',
        sortable: false,
      },

      {
        text: 'File Name',
        value: 'mid',
        width: '210',
        sortable: false,
        align: 'center',
      },
      {
        text: 'User ID',
        value: 'merchant_name',
        width: '190',
        align: 'center',
        sortable: false,
      },

      {
        text: 'Upload Date',
        value: 'sales_volume',
        width: '210',
        align: 'center',
        sortable: false,
      },
      {
        text: 'Status',
        value: 'date',
        width: '150',
        sortable: false,
        align: 'center',
      },

      {
        text: 'Action',
        value: 'merchant_criteria',
        width: '90',
        align: 'left',
        sortable: false,
      },
    ],

    upload: {
      created_at: [],
      file_upload: '',
    },

    selectedRow: '',
    dateFormatted: '',
    dateMenu: false,
    editedIndex: -1,
  }),

  computed: {
    allData() {
      return this.$store.state.monitoringMerchant.allData;
    },

    totalData() {
      return this.$store.state.monitoringMerchant.totalData;
    },

    totalPage() {
      return this.$store.state.monitoringMerchant.totalPage;
    },

    loading() {
      return this.$store.state.monitoringMerchant.loading;
    },

    flashError: {
      get() {
        return this.$store.state.monitoringMerchant.flashError;
      },
      set() {
        this.$store.commit('monitoringMerchant/setFlashErrorMessage', '');
      },
    },
    flashErrorMessage() {
      return this.$store.state.monitoringMerchant.flashErrorMessage;
    },

    dateRangeText() {
      return this.upload.created_at.join(' ~ ');
    },
    minDate() {
      if (this.upload.created_at.length > 0) {
        const tempMinDate = Date.parse(this.upload.created_at[0]);
        return this.getDate(dataMinRangeDate, tempMinDate);
      }
      return '';
    },
    maxDate() {
      if (this.upload.created_at.length > 0) {
        const tempMaxDate = Date.parse(this.upload.created_at[0]);
        const maxDate = this.getDate(dataMaxRangeDate, tempMaxDate);
        return maxDate > this.today ? this.today : maxDate;
      }
      return this.today;
    },
  },

  watch: {
    options: {
      handler() {
        if (!this.isFirstLoad) {
          this.getData();
        } else {
          this.$store.commit('monitoringMerchant/clearData');
        }
        this.isFirstLoad = false;
      },
      deep: true,
    },
  },

  methods: {
    checkRangeDate() {
      if (this.upload.created_at.length == 1) {
        this.upload.created_at.push(this.upload.created_at[0]);
      }

      const result = this.getValDate(this.upload.created_at);
      if (result > 30) {
        showAlert(
          this.$store,
          'Range date must be <= 31 days',
          'mdi-alert',
          'red'
        );
        return false;
      }
      return true;
    },

    selectRow(index) {
      if (this.selectedRow != index) {
        this.selectedRow = index;
      } else {
        this.selectedRow = '';
      }
    },

    rowClass() {
      const rowClass = 'max-width-col';
      return rowClass;
    },

    getValDate(dateVal) {
      const date1 = new Date(dateVal[0]);
      const date2 = new Date(dateVal[1]);
      const diffTime = Math.abs(date2 - date1);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      return diffDays;
    },

    showData() {
      this.getData();
    },

    getData() {
      if (this.upload.created_at.length < 1) {
        this.$vuetify.goTo(0);
        showAlert(
          this.$store,
          'transaction date is required !',
          'mdi-alert',
          'red'
        );
      } else {
        this.$store.commit('monitoringMerchant/setFlashErrorMessage', '');
        const { page, itemsPerPage, sortBy, sortDesc } = this.options;
        this.$store
          .dispatch('monitoringMerchant/getData', {
            date,
            page,
            itemsPerPage,
            sortBy,
            sortDesc,
            search: this.upload,
          })
          .then(() => {
            if (this.totalPage < page) {
              if (this.totalPage == 0) {
                this.options.page = 1;
              } else {
                this.options.page = this.totalPage;
              }
            }
          });
      }
    },

    clearSearch() {
      alert(this.upload.file_upload);
      this.upload.file_upload = '';
      this.upload.created_at = [];
    },

    formatDate(dateVal) {
      if (!dateVal) return null;

      const [year, month, day] = dateVal.split('-');
      return `${day}/${month}/${year}`;
    },

    parseDate(dateVal) {
      if (!dateVal) return null;

      const [day, month, year] = dateVal.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
    getDate,
  },
};
</script>

<style scoped>
.setFormInput {
  margin-top: 0%;
}
.btnspace {
  margin-left: 5px;
  margin-top: 20px;
}
.max-width-col td {
  white-space: nowrap;
  overflow: hidden;
  max-width: 250px;
  text-overflow: ellipsis;
}
.v-data-table .v-data-table__wrapper {
  height: 100%;
}
</style>
